import { Injectable } from "@angular/core";
import { ProgressItem as ProgressItemDto } from "src/app/proxy/progresses/models";
import { ProgressItem } from "../../entities/progress-item";
import { LocalDbService } from "../local-db-service";

@Injectable({ providedIn: 'root' })
export class ProgressItemRepository {
  private get table() {
    return this.db.progressItemsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<ProgressItem[]> {
    const rows = await this.table.toArray();
    return this.mapRows(rows);
  }

  async getAllByActivityReportId(activityReportId: string): Promise<ProgressItem[]> {
    const rows = await this.table.where('activityReportId').equals(activityReportId).toArray();
    return this.mapRows(rows);
  }

  async create(item: ProgressItem | ProgressItemDto): Promise<string> {
    const row = new ProgressItem(item);
    await this.table.add(row);
    return row.localId;
  }

  async upsertBulk(items: Array<ProgressItem | ProgressItemDto>): Promise<void> {
    if (items.length === 0) {
      return;
    }

    const rows = items.map(item => new ProgressItem(item));
    await this.table.bulkPut(rows);
  }

  async delete(id: number): Promise<void> {
    await this.table.where('id').equals(id).delete();
  }

  async deleteAllByActivityReportId(activityReportId: string): Promise<number> {
    return this.table.where('activityReportId').equals(activityReportId).delete();
  }

  async clear(): Promise<void> {
    await this.table.clear();
  }

  private mapRows(rows: ProgressItem[]): ProgressItem[] {
    return rows.map(row => new ProgressItem(row));
  }
}
